/* global angular */

angular.module('gc.ui.contentselectable', [])
.service('SelectionCoordinate', [
'$window',
function ($window) {
  'use strict';

  this.getSelectionInfos = function (win) {
    win = win || $window;
    var doc = win.document;
    var sel = doc.selection, range, rect;
    var x = 0, y = 0, width = 0, height = 0, text='';
    if (sel) {
      if (sel.type !== 'Control') {
        range = sel.createRange();
        range.collapse(true);
        x = range.boundingLeft;
        y = range.boundingTop;
        width = range.boundingWidth;
        height = range.boundingHeight;
      }
    } else if (win.getSelection) {
      text = window.getSelection().toString();
      sel = win.getSelection();
      if (sel.rangeCount) {
        range = sel.getRangeAt(0).cloneRange();
        if (range.getBoundingClientRect) {
          rect = range.getBoundingClientRect();
          range.collapse(true);
          x = rect.left;
          y = rect.top;
          width = rect.right - rect.left;
          height = rect.bottom - rect.top;
        }
        // Fall back to inserting a temporary element
        if (x === 0 && y === 0) {
          var span = doc.createElement('span');
          if (span.getClientRects) {
            // Ensure span has dimensions and position by
            // adding a zero-width space character
            span.appendChild(doc.createTextNode('\u200b'));
            range.insertNode(span);
            rect = span.getClientRects()[0];
            if (rect) {
              x = rect.left;
              y = rect.top;
              width = rect.right - rect.left;
              height = rect.bottom - rect.top;
              var spanParent = span.parentNode;
              spanParent.removeChild(span);

              // Glue any broken text nodes back together
              spanParent.normalize();
            }
          }
        }
      }
    }
    return {x: x, y: y, width: width, height: height, text: text};
  };

}])
.directive('contentSelectable', [
'SelectionCoordinate',
function (SelectionCoordinate) {
  'use strict';
  return {
    restrict: 'A',
    scope: {
      contentSelectControl: '='
    },
    link: function ($scope, $element) {

      $scope.iControl = $scope.contentSelectControl || {};

      var contentEl = $element[0];

      /*****************************************************************************************************************
       * LISTENER
       ****************************************************************************************************************/

      // bind selection change event to my function
      contentEl.addEventListener('mouseup', onSelection);

      function onSelection(event) {
        // only allow left click to open smedPopup
        // (right click seems to trigger selection on Chrome Ubuntu)
        if (event.which !== 1) return;

        if (typeof $scope.iControl.onSelection === 'function') {
          var infos =  SelectionCoordinate.getSelectionInfos();

          if (infos.text) {
            $scope.iControl.onSelection(contentEl, infos);
          }
        }
      }
    }
  };
}]);
